import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
interface Reason {
  "@id": string;
  "@type": string;
  key: string;
  value: string;
}
export const useReasonQuery = type => {
  const $ = _c(2);
  let t0;
  if ($[0] !== type) {
    t0 = {
      queryKey: ["reasons", type],
      queryFn: async () => {
        const response = await fetch(`/api/reason?type=${type}`);
        if (!response.ok) {
          throw new Error("Erreur lors de la r\xE9cup\xE9ration des motifs");
        }
        return response.json();
      }
    };
    $[0] = type;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};